<template>
  <card-modal :visible="visible" @close="close" :height="height" transition="zoom" ref="modal">
    <div class="customer-edit-box" slot="body" :style="style">
      <h4 class="page-title">{{$t('page_title')}} [{{props_data.index + 1}}{{$t('person')}}]</h4>
      <h4 class="page-title-s">{{$t('page_title_s')}} [{{props_data.index + 1}}{{$t('person')}}]</h4>
      <div class="popup-contents-box">

        <div class="sub-contents-box">
          <div class="customer-info">
            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('name')}}</p>
              <p class="info-item"><input type="text" name="name" v-model="customer_info.name" /></p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('sex')}}</p>
              <p class="info-item">
                <input id="sex1" type="radio" name="sex" v-model="customer_info.sex" value="1"/>
                <label for="sex1">{{$t('sex1')}}</label>
                <input id="sex2" type="radio" name="sex" v-model="customer_info.sex" value="2"/>
                <label for="sex2">{{$t('sex2')}}</label>
              </p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('age')}}</p>
              <p class="info-item"><input type="number" class="s-width" min="0" max="200" name="age" v-model.number="customer_info.age"></p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red" v-if="props_data.index == 0">※</span>{{$t('email')}}</p>
              <p class="info-item"><input type="text" name="email" v-model="customer_info.email"></p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('address')}}</p>
              <p class="info-item"><input type="text" name="address" v-model="customer_info.address"></p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red" v-if="props_data.index == 0">※</span>{{$t('tel')}}</p>
              <p class="info-item"><input type="text" placeholder="ex: 000-0000-0000" v-model="customer_info.tel"></p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('job')}}</p>
              <p class="info-item"><input type="text" v-model="customer_info.occuoation"></p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('p_dext')}}</p>
              <p class="info-item">
                <input type="text" v-model="customer_info.prior_destination">
                <span>{{$t('pn_about')}}</span>
              </p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('n_dext')}}</p>
              <p class="info-item">
                <input type="text" v-model="customer_info.next_destination">
                <span>{{$t('pn_about')}}</span>
              </p>
            </div>

            <div class="flex">
              <p class="info-title"><span v-if="(datepicker_lang != 'ja')" class="red">※</span>{{$t('nationality')}}</p>
              <p class="info-item"><input type="text" v-model="customer_info.nationality"></p>
            </div>

            <div class="flex">
              <p class="info-title"><span v-if="(datepicker_lang != 'ja')" class="red">※</span>{{$t('passport_no')}}</p>
              <p class="info-item"><input type="text" v-model="customer_info.passport_no"></p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('check_in')}}</p>
              <p class="info-item">{{customer_info.check_in}}</p>
            </div>

            <div class="flex">
              <p class="info-title"><span class="red">※</span>{{$t('check_out')}}</p>
              <p class="info-item">{{customer_info.check_out}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('room_name')}}</p>
              <p class="info-item"><input class="" disabled type="text" v-model="customer_info.room_name"/></p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('other')}}</p>
              <p class="info-item"><textarea class="" v-model="customer_info.other"></textarea></p>
            </div>

            <div class="flex">
              <p class="info-title"><span v-if="(datepicker_lang != 'ja')" class="red">※</span>{{$t('passport_copy')}}</p>
              <p class="info-item">
                <img :src="dataUrl" v-if="dataUrl">
              </p>
            </div>

          </div>
          <p><span class="red2">※</span>{{$t('required_fields')}}</p>
          <p><span class="red2">※</span>{{$t('required_fields2')}}</p>
        </div>

      </div>
      <div class="flex2">
        <input type="button" class="new-add" @click="cancel" :value="$t('back')" />
        <input type="button" class="new-add" @click="send" :value="$t('registration')" />
      </div>

    </div>
  </card-modal>
</template>

<script>
import BaseModal from '@/lib/BasePopup';
// import vuejsDatepicker from 'vuejs-datepicker';
// import * as lang from "vuejs-datepicker/src/locale";
export default {
  mixins: [BaseModal],
  name: 'CustomerEdit',
  // ===========================================================================
  // language
  // ===========================================================================
  language: {
    'ja': {
      'page_title': '宿泊者情報詳細',
      'page_title_s': '宿泊者情報詳細',
      'name': 'お名前',
      'sex': '性別',
      'age': '年齢',
      'post_no': '郵便番号',
      'email': 'email',
      'address': 'ご住所',
      'tel': '電話番号',
      'job': 'ご職業',
      'p_dext': '前泊地',
      'n_dext': '行先地',
      'pn_about': '（分からない場合は、国や住所の地名を記入してください。）',
      'nationality': '国籍',
      'passport_no': 'パスポート番号',
      'check_in': 'ご到着',
      'check_out': 'ご出発',
      'room_name': '客室名',
      'other': 'その他(合計宿泊人数)',
      'person': '人目',
      'back': '戻る',
      'registration': '登録',
      'sex1': '男',
      'sex2': '女',
      'passport_copy': 'パスポートのコピー',
      'fileup': 'ファイルを選択',
      'required_fields': 'は必ず入力してください。',
      'required_fields2': '日本国籍以外の方は、パスポート番号記載の上、パスポートのコピーをアップロードしてください。',
      'enter_err': '未入力の項目：',
      'enter_ok': '宿泊者情報を登録しました。',
    },
    'en': {
      'page_title': 'Guest information details',
      'page_title_s': 'Guest information',
      'name': 'Guest name\n客人姓名\n손님 이름',
      'sex': 'Sex\n性别\n섹스',
      'age': 'Age\n年龄\n나이',
      'post_no': 'Postal code',
      'email': 'email',
      'address': 'Address\n地址\n주소',
      'tel': 'Phone number\n电话号码\n전화 번호',
      'job': 'Occupation\n占用\n직업',
      'p_dext': 'Prior Destination\n预先目的地\n이전 목적지',
      'n_dext': 'Next Destination\n下一个目的地\n다음 목적지',
      'pn_about': '（If you do not understand, please fill in the place name of the country or address.）',
      'nationality': 'Nationality\n国籍\n국적',
      'passport_no': 'Passport No.',
      'check_in': 'Check-in.\n报到\n체크인',
      'check_out': 'Check-out.\n查看\n점검',
      'room_name': 'Room No.\n房间号\n객실 번호',
      'other': 'Other',
      'person': ' person',
      'back': 'back',
      'registration': 'Register',
      'sex1': 'Male',
      'sex2': 'Female',
      'passport_copy': 'copy of passport\n护照复印件\n여권 사본',
      'fileup': 'Select file',
      'required_fields': ' is required fields.',
      'required_fields2': ' If you are not a Japanese national, you should upload your copy of your passport by posting your passport number.',
      'enter_err': 'Please enter ',
      'enter_ok': 'Registered guest information.'
    }
  },
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    // vuejsDatepicker,
  },
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    props_data: null,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      width: 'calc(100vw - 60px)',
      height: '100%',
      datepicker_lang: this.$store.getters['loginInfo/lang'],

      customer_info: {},
      check_in: {},
      check_out: {},
      dataUrl: null,
      edit_flg: false,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    if (this.props_data.list.id) {

      let ld = new this.$loader(this);
      ld._data_set({customer_id: this.props_data.list.id});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('customer_info_get.php');
    } else {
      this.customer_info.check_in = this.props_data.lodg_data.check_in;
      this.customer_info.check_out = this.props_data.lodg_data.check_out;
      this.customer_info.room_name = this.props_data.lodg_data.listing_name;
    }
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get_cb (res) {
      this.customer_info = res.data.customer_info;

      let work = null;
      let work2 = null;
      if (res.data.customer_info.check_in) {
        work = res.data.customer_info.check_in.split('-');
        work2 = work[1].split(':');
        this.check_in.h = work2[0];
        this.check_in.m = work2[1];
      }
      if (res.data.customer_info.check_out) {
        work = res.data.customer_info.check_out.split('-');
        work2 = work[1].split(':');
        this.check_out.h = work2[0];
        this.check_out.m = work2[1];
      }

      this.datepicker_lang = this.props_data.lodg_data.language;
      this.dataUrl = res.data.customer_info.passport;
    },
    cancel () {
      if (this.edit_flg === true) {
        this.props_data.cb();
      }
      this.close();
    },
    send () {
      if (this.$lib._emptyChk(this.customer_info.name) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('name')));
        return;
      }
      if (this.$lib._emptyChk(this.customer_info.age) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('age')));
        return;
      }
      if (this.$lib._emptyChk(this.customer_info.address) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('address')));
        return;
      }
      if (this.props_data.index === 0 && this.$lib._emptyChk(this.customer_info.email) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('email')));
        return;
      }
      if (this.props_data.index === 0 && this.$lib._emptyChk(this.customer_info.tel) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('tel')));
        return;
      }
      if (this.$lib._emptyChk(this.customer_info.occuoation) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('job')));
        return;
      }
      if (this.$lib._emptyChk(this.customer_info.next_destination) === false) {
        this.$alert('alert', (this.$t('enter_err') + this.$t('n_dext')));
        return;
      }
      if (this.props_data.lodg_data.language !== 'ja') {
        // 日本以外
        if (this.$lib._emptyChk(this.customer_info.nationality) === false) {
          this.$alert('alert', (this.$t('enter_err') + this.$t('nationality')));
          return;
        }
        if (this.$lib._emptyChk(this.customer_info.passport_no) === false) {
          this.$alert('alert', (this.$t('enter_err') + this.$t('passport_no')));
          return;
        }
      }

      // orderを設定
      this.customer_info.order = this.props_data.index + 1;

      let ld = new this.$loader(this);
      ld._data_set({customer_info: this.customer_info});
      ld._post_cb_f = this.upload_cb;
      ld._load_start('admin_customer_edit.php');
    },
    upload_cb () {
      this.$alert('info', this.$t('enter_ok'));
      this.edit_flg = true;
      this.cancel();
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.customer-edit-box {
  background-color: #fefefe;
  padding: 20px;
  .popup-contents-box {
    margin: 20px 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    // height: calc(100vh - 255px);
    height: calc(100% - 120px);
    .guide-p {
      height: 40px;
      overflow: auto;
    }
  }
  .sub-contents-box {
    margin-bottom: 0px;
    margin-right: 0px;
  }
  h4 {
    font-size: 18px;
    border-bottom: solid 1px #d3d4d8;
    width: 100%;
    padding: 0px 0px 5px 0px;
    color: #24273b;
  }
  .page-title-s {
    display: none;
  }
  .new-add {
    display: block;
    text-align: center;
    padding: 8px 8px 8px 8px;
    font-size: 16px;
    text-decoration: none;
    border-radius: 3px;
    width: 150px;
  }

  .customer-info {
    border-bottom: 1px solid #d3d4d8;
  }

  .info-title {
    min-width: 180px;
    padding: 6px 13px 3px 3px;
    background: #fbfbfb;
    text-align: right;
    line-height: 1.5;
    border-top: 1px solid #d3d4d8;
    border-left: 1px solid #d3d4d8;
    color: #24273b;
    white-space: pre-wrap;
  }

  .info-item {
    padding: 5px;
    flex: 1;
    border-top: 1px solid #d3d4d8;
    border-left: 1px solid #d3d4d8;
    border-right: 1px solid #d3d4d8;
  }
  .flex2 {
    display: flex;
    justify-content:space-between;
  }
  .flex3 {
    display: flex;
  }
  .vdp-datepicker {
    width: 100px;
    margin-right: 10px;
  }
  .s-width {
    width: 80px;
  }
  img {
    width: 100%;
  }
  label > input {
    display:none;	/* アップロードボタンのスタイルを無効にする */
  }
  .file-label {
    color: #ff6e5a;
    display: block;
    text-align: center;
    padding: 1px;
    font-size: 16px;
    text-decoration: none;
    border-radius: 3px;
    width: 150px;
    font-weight: 800;
    background-color: #f6f6f7;
    border: 1px solid #ff6e5a;
    transition: all 0.2s ease;
  }
  .file-label:hover {
    color: #24273b;
    border: 1px solid #24273b;
  }
  .red {
    color: #ff6e5a;
    float: right;
  }
  .red2 {
    color: #ff6e5a;
  }
  @media (max-width: 767px) {
    .customer-info {
      border: initial;
    }
    .flex {
      display: block;
      border: initial;
    }
    .info-title {
      width: auto;
      padding: 3px;
      border: initial;
      text-align: left;
    }

    .info-item {
      padding: 5px;
      border: initial;
    }

    .page-title {
      display: none;
    }

    .page-title-s {
      display: inline-block;
    }

    .new-add {
      width: 120px;
    }
  }
}
</style>
